import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"
import SectionTitle from "../components/common/SectionTitle"
import CategoryCard from "../components/categories/CategoryCard"

import { categories } from "../data/categories"

export default function Categories() {
  return (
    <>
      <SEO
        title="Catégories"
        description="Découvrez toutes nos catégories de produits textiles, mercerie, tissus, fermetures, fils, élastiques, velcro, boutons et accessoires."
        keywords="catégories textile, mercerie, tissus, fermetures, fils, élastiques, velcro, boutons"
        url="https://www.khenissitextiles.com/categories"
      />

      <PageBanner
        title="Nos Catégories"
        subtitle="Explorez l'ensemble de nos familles de produits destinées aux professionnels du textile et de la confection."
      />

      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">

          <SectionTitle
            badge="Catalogue"
            title="Toutes nos catégories"
            description="Retrouvez facilement les produits dont vous avez besoin grâce à notre catalogue organisé par catégories."
          />

          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3 mt-12">
            {categories.map((category) => (
              <CategoryCard
                key={category.id}
                category={category}
              />
            ))}
          </div>

        </div>
      </section>
    </>
  )
}